// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"gM-z","carouselContainer":"hM-z"};